export default __webpack_public_path__ + "static/media/Pe-icon-7-stroke.11f7c073.woff";